import styled from 'styled-components';
import * as grid from 'view/styles/grid';

interface NoteContentContainerProps {
    isCentered?: boolean;
}

const spacing = grid.multiple(8).px;

export const NoteContentContainer = styled.div<NoteContentContainerProps>`
    margin: ${spacing};
    max-width: ${grid.multiple(44).px};
    text-align: ${(props) => (props.isCentered ? 'center' : 'start')};
`;
